import { useAuthStore } from "../../stores/auth.ts";
import appWindow from "../../utils/app-window.ts";
import isEmailAllowed from "../../utils/is-email-allowed.ts";
import isImpersonateUserAllowed from "../../utils/is-impersonate-user-allowed.ts";

type IsImpactCenterAllowed = () => boolean;

const isImpactCenterAllowed: IsImpactCenterAllowed = () => {
  if (appWindow.IMPACT_CENTER_PUBLICLY_OPENED === "true") {
    return true;
  }

  const email = useAuthStore().user?.email;

  return (
    isEmailAllowed(email, appWindow.IMPACT_CENTER_ALLOWED_EMAILS) ||
    isImpersonateUserAllowed(email)
  );
};

export default isImpactCenterAllowed;
